import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementBadge = ({ badge, onClick }) => {
  const getBadgeColor = (rarity) => {
    switch (rarity) {
      case 'Common':
        return 'from-gray-400 to-gray-600';
      case 'Rare':
        return 'from-blue-400 to-blue-600';
      case 'Epic':
        return 'from-purple-400 to-purple-600';
      case 'Legendary':
        return 'from-yellow-400 to-yellow-600';
      default:
        return 'from-gray-400 to-gray-600';
    }
  };

  return (
    <div
      onClick={() => onClick(badge)}
      className="bg-card rounded-xl border border-border p-4 hover:shadow-lg transition-all duration-300 cursor-pointer group"
    >
      <div className="flex flex-col items-center text-center">
        <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${getBadgeColor(badge?.rarity)} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300 ${!badge?.earned && 'opacity-40 grayscale'}`}>
          <Icon name={badge?.icon} size={32} color="white" />
        </div>
        <h4 className="text-sm font-semibold text-foreground mb-1">{badge?.title}</h4>
        <p className="text-xs text-muted-foreground mb-2 line-clamp-2">{badge?.description}</p>
        {badge?.earned ? (
          <div className="flex items-center gap-1 text-xs text-success">
            <Icon name="CheckCircle" size={14} />
            <span>Earned</span>
          </div>
        ) : (
          <div className="text-xs text-muted-foreground">
            {badge?.progress}% Complete
          </div>
        )}
      </div>
    </div>
  );
};

export default AchievementBadge;